const MenuModule = {
  state: {
    menuOpen: false
  },
  mutations: {
    changeMenu (state, newState) {
      state.menuOpen = newState
    }
  }
};

export default MenuModule;
